import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import { NtvService as NoticeToVacateService } from '../../../services/ntv.service';

@Component({
  selector: 'app-error',
  templateUrl: './ntverror.component.html',
  styleUrls: ['./ntverror.component.css']
})

export class NtvErrorComponent implements OnInit {

  errorMessage: string;
  private sub: any;

  constructor(
    public ntvService: NoticeToVacateService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) 
  {
    this.errorMessage = localStorage.getItem('NTVErrorMessage');
  }

  ngOnInit() {
  }

}
